<template>
  <div>
    <el-tabs type="border-card" v-model="card_index">
      <el-tab-pane label="分摊表信息" name="VirtuallyData">
        <VirtuallyData v-if="card_index==='VirtuallyData'" />
      </el-tab-pane>
      <el-tab-pane label="分摊公式" name="VirtuallyFunction">
        <VirtuallyFunction v-if="card_index==='VirtuallyFunction'" />
      </el-tab-pane>
      <el-tab-pane label="分摊客户" name="VirtuallyCustomer">
        <VirtuallyCustomer v-if="card_index==='VirtuallyCustomer'" />
      </el-tab-pane>
      <el-tab-pane label="分摊示意图" name="VirtuallyMap">
        <VirtuallyMap v-if="card_index==='VirtuallyMap'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import VirtuallyData from "./VirtuallyData";
import VirtuallyFunction from "./VirtuallyFunction";
import VirtuallyMap from "./VirtuallyMap";
import VirtuallyCustomer from "./VirtuallyCustomer";
export default {
  name: "VirtuallyEditor",
  components: {VirtuallyCustomer, VirtuallyMap, VirtuallyFunction, VirtuallyData},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      card_index:"VirtuallyData"
    }
  },
  computed:{
    isVirtuallyEditor(){
      return this.componentId==='VirtuallyEditor'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/MeterVirtually/components/virtually/VirtuallyEditor.vue